import { render, staticRenderFns } from "./Withdrawals.vue?vue&type=template&id=21e290c6&scoped=true&"
import script from "./Withdrawals.vue?vue&type=script&lang=js&"
export * from "./Withdrawals.vue?vue&type=script&lang=js&"
import style0 from "./Withdrawals.vue?vue&type=style&index=0&id=21e290c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e290c6",
  null
  
)

export default component.exports